export const ROLE_LABELS = {
    admin: "Admin",
    manager: "Manager",
    staff: "Staff",
    cashier: "Cashier",
};

const HIERARCHY = { admin: 4, manager: 3, staff: 2, cashier: 1 };

export function hasRole(user, minRole) {
    if (!user) return false;
    return (HIERARCHY[user.role] || 0) >= (HIERARCHY[minRole] || 0);
}

export function canAccess(user, page) {
    if (!user) return false;
    const map = {
        dashboard: "cashier",
        products: "staff",
        categories: "manager",
        inventory: "staff",
        lowstock: "staff",
        sales: "cashier",
        orders: "cashier",
        purchases: "staff",
        customers: "cashier",
        suppliers: "manager",
        payments: "cashier",
        files: "staff",
        users: "admin",
        reports: "manager",
    };
    const min = map[page] || "admin";
    return hasRole(user, min);
}
